import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    count: 0, // Initial notification count
  },
  reducers: {
    setNotificationCount: (state, action) => {
      state.count = action.payload;
    },
    incrementNotificationCount: (state) => {
      state.count += 1;
    },
    resetNotificationCount: (state) => {
      state.count = 0;
    },
  },
});

export const {
  setNotificationCount,
  incrementNotificationCount,
  resetNotificationCount,
} = notificationSlice.actions;

export default notificationSlice.reducer;
